import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

// Timeline state interface - Define the shape of timeline state
export interface TimelineState {
  groups: TimelineGroup[];
  items: TimelineItem[];
  startDate: string | null;
  endDate: string | null;
  isLoading: boolean;
  observationTable: Record<string, any>;
  rawEvents: any[];
  latestEpisodeId: string | null;
}

export interface TimelineItem {
  id: number;
  group: number;
  start_time: number;
  end_time: number;
  type: string;
  cnt?: number;
  showInSimple?: boolean;
  showInComplex?: boolean;
  showInExpanded?: boolean;
  showInCollapsed?: boolean;
  order?: number;
  group_type?: string;
  parent_name?: string;
  insight_id?: string | number;
  [key: string]: any;
}

export interface TimelineGroup {
  id: number;
  title: string;
  stackItems?: boolean;
  root?: boolean;
  parent?: number | null;
  cnt?: number;
}

// Initial state with proper typing
const initialState: TimelineState = {
  groups: [],
  items: [],
  startDate: null,
  endDate: null,
  isLoading: false,
  observationTable: {},
  rawEvents: [],
  latestEpisodeId: null,
};

// Payload interface for setEventList action
interface SetEventListPayload {
  groups: any[];
  items: any[];
  startDate: string | null;
  endDate: string | null;
  observationTable: Record<string, any>;
  rawEvents: any[];
  latestEpisodeId: string | null;
}

export const timelineSlice = createSlice({
  name: 'timeline',
  initialState,
  reducers: {
    startLoadingEvents: (state) => {
      state.isLoading = true;
    },
    endLoadingEvents: (state) => {
      state.isLoading = false;
    },
    setEventList: (state, action: PayloadAction<SetEventListPayload>) => {
      const { payload } = action;
      state.groups = payload.groups;
      state.items = payload.items;
      state.startDate = payload.startDate;
      state.endDate = payload.endDate;
      state.isLoading = false;
      state.observationTable = payload.observationTable;
      state.rawEvents = payload.rawEvents;
      state.latestEpisodeId = payload.latestEpisodeId;
    },
  },
});

// Action creators are generated for each case reducer function
export const { startLoadingEvents, setEventList, endLoadingEvents } =
  timelineSlice.actions;
